export enum FormMode {
    Default = 'DEFAULT',
    EditMine = 'EDIT_MINE', // Edition mode as organization leader
    Add = 'ADD', // Creation mode as admin
    Edit = 'EDIT', // Edition mode as admin
}
